const formatToCurrencyBrl = (value) => {
  if (!value) {
    value = Math.floor('').toLocaleString('pt-br', { minimumFractionDigits: 2 })
  }

  return value.toLocaleString('pt-br', { minimumFractionDigits: 2 })
}

export default formatToCurrencyBrl
